var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"side-menu",attrs:{"default-openeds":[
    'devtools-id',
    'devtools-crypto',
    'devtools-format-json',
  ],"default-active":_vm.defaultActive},on:{"select":_vm.handleSelect}},_vm._l((_vm.sideMenu),function(menu){return _c('el-submenu',{key:menu.groupId,attrs:{"index":menu.groupId}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(_vm._s(menu.groupName))]),_vm._l((menu.items),function(item){return _c('el-menu-item',{key:item.id,attrs:{"index":item.id}},[_vm._v(_vm._s(item.name))])})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }